// polyfills for ie and es staged

// browser polyfills
import polyfills from '../polyfills';
import ownDoc from 'dom-helpers/ownerDocument';

import toggler from './toggler';
import videoPlayer from './video';
import lazyLoad from './lazy-load';
import textEllipsis from './text-ellipsis';
import responsivefb from './responsivefb';
import embebScripts from './embed-scrips';
import { subscribeForm } from './subscribe-news';

export default stores => {
  const doc = ownDoc();

  polyfills();
  toggler(doc);
  videoPlayer(doc);
  textEllipsis(doc);
  lazyLoad(doc);
  responsivefb(doc);
  subscribeForm(doc, stores);
  embebScripts(doc);
};
